<template>
  <div class="padded padded">
    <h3><i class="fa fa-money-bill-alt" />&nbsp;Finance</h3>

    <el-tabs :tab-position="isDesktop ? 'left' : 'top'" v-model="activeTab">

      <el-tab-pane name="tabSum">
        <span class="text-info" slot="label"><i class="fa fa-globe text-muted"></i> Summary</span>

        <finance-summary :site-id="siteData.id" />
      </el-tab-pane>


      <el-tab-pane name="tabSharers" lazy>
        <span class="text-info" slot="label"><i class="fa fa-users text-muted"></i> Sharers</span>

        <site-finance-sharers :row-data="siteData" :sharers="sharers" />
      </el-tab-pane>

<!--
      <el-tab-pane label="Revenue" name="tabRev" lazy>
        <site-revenue :row-data="siteData" :sharers="sharers" />
      </el-tab-pane>
-->

      <el-tab-pane label="Contractors" name="tabCont" lazy>
        <site-contractors :site-id="siteData.id" />
      </el-tab-pane>

      <el-tab-pane name="tabUtil" lazy>
        <span class="text-info" slot="label"><i class="fa fa-plug text-muted"></i> Utilities</span>

        <site-util :row-data="siteData" :sharers="sharers" />
      </el-tab-pane>


      <el-tab-pane name="tabProp" lazy>
        <span class="text-info" slot="label"><i class="fa fa-home text-muted"></i> Property</span>

        <site-tenancy :row-data="siteData" />
      </el-tab-pane>

<!--
      <el-tab-pane label="Backhaul Payments" name="tab4">
        <site-finance-backhaul :row-data="siteData" />
      </el-tab-pane>
-->
    </el-tabs>

  </div>

</template>



<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'

import SiteContractors from '@/components/sites/finance/contractors/SiteContractors'

import FinanceSummary from '@/components/dashboard/views/FinanceSummary'
import SiteFinanceSharers from '@/components/sites/finance/SiteFinanceSharers'

import SiteTenancy from '@/components/sites/finance/tenancy/SiteTenancy'

import SiteRevenue from '@/components/sites/finance/revenue/SiteRevenue'
import SiteUtil from '@/components/sites/utility/SiteUtil'


export default {
  mixins: [ArrayMixins, SiteMixins],

  components: {
    SiteContractors,
    SiteFinanceSharers,
    FinanceSummary,
    SiteTenancy,
    SiteRevenue,
    SiteUtil
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

/*
  computed: {
    dueAdvance: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'A' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    },

    dueSharing: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    },

    dueFees: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'L' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    },

    paid: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'L' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].totalPaid ? Number(this.summary[i].totalPaid) : 0
          }
        }
      }

      return this.formatMoney(res, 0)
    }

  },
*/

  methods: {

    fetchSharers (data) {
      this.sharers = data
    }

  },



  data () {
    return {
      editing: this.editMode,
      canEdit: this.canAccess('finance') && this.isManager(),
      activeTab: 'tabSum',
      localSite: this.siteData,
      sharers: [],
      summary: [],
      showDialog: false,
      outstanding: 0,
      agreement: null
    }
  },

  created () {
    this.findSiteSharers(this.siteData.id, this.fetchSharers)
  }

}
</script>



// WEBPACK FOOTER //
// SiteFinance.vue?0eaa64bd